import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 40, fontSize: 10, fontFamily: 'Helvetica', color: '#333' },
  header: { marginBottom: 20, borderBottomWidth: 1, borderBottomColor: '#000', paddingBottom: 10 },
  title: { fontSize: 18, fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase' },
  section: { marginBottom: 15 },
  sectionTitle: { fontSize: 11, fontWeight: 'bold', backgroundColor: '#f2f2f2', padding: 4, marginBottom: 8, borderLeftWidth: 3, borderLeftColor: '#ff9f43' },
  row: { flexDirection: 'row', marginBottom: 4, borderBottomWidth: 0.5, borderBottomColor: '#eee', paddingBottom: 2 },
  label: { fontWeight: 'bold', width: 140, color: '#555' },
  value: { flex: 1 },
  table: { width: '100%', marginTop: 5, borderStyle: 'solid', borderWidth: 0.5, borderColor: '#ccc' },
  tableRow: { flexDirection: 'row', borderBottomWidth: 0.5, borderBottomColor: '#ccc', minHeight: 20, alignItems: 'center' },
  tableHeader: { backgroundColor: '#f9f9f9' },
  tableCell: { flex: 1, padding: 4, textAlign: 'center', borderRightWidth: 0.5, borderRightColor: '#ccc' },
  tableCellLabel: { flex: 1.5, padding: 4, textAlign: 'left', borderRightWidth: 0.5, borderRightColor: '#ccc', fontWeight: 'bold' },
  tableCellLast: { flex: 0.5, padding: 4, textAlign: 'center' },
  textBlock: { marginTop: 5, padding: 8, backgroundColor: '#fafafa', borderLeftWidth: 2, borderLeftColor: '#ccc', fontStyle: 'italic' }
});

const formatDate = (dateString) => {
  if (!dateString) return 'A definir';
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

const RequestDocument = ({ request }) => {
  const accommodationMap = { HOTEL: 'Hotel', CABANA: 'Cabaña', APART: 'Apartamento', RESORT: 'Resort', HOSTE: 'Hostel' };
  const categoryMap = { ESTANDAR: 'Estándar', SUPERIOR: 'Superior', LUJO: 'Lujo', INDIFERENTE: 'Indiferente' };
  const mealPlanMap = { SIN_PENSION: 'Sin Pensión', DESAYUNO: 'Desayuno', MEDIA_PENSION: 'Media Pensión', ALL_INCLUSIVE: 'Todo Incluido' };
  const roomTypeMap = { SIMPLE: 'Simple', DOBLE: 'Doble', TRIPLE: 'Triple', SUITE_FAMILIAR: 'Suite Familiar' };

  return (
    <Document title={`Solicitud_${request.id}_${request.passenger?.surname || 'Cliente'}`}>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.title}>Hoja de Solicitud de Viaje #{request.id}</Text>
          <Text style={{ textAlign: 'right', fontSize: 8, marginTop: 5 }}>Generado el: {new Date().toLocaleDateString('es-AR')}</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>DATOS DEL PASAJERO TITULAR</Text>
          <View style={styles.row}><Text style={styles.label}>Apellido y Nombre:</Text><Text style={styles.value}>{request.passenger?.surname} {request.passenger?.name}</Text></View>
          <View style={styles.row}><Text style={styles.label}>DNI / Documento:</Text><Text style={styles.value}>{request.passenger?.dni || 'N/A'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Teléfono de contacto:</Text><Text style={styles.value}>{request.passenger?.phoneNumber || 'N/A'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Email:</Text><Text style={styles.value}>{request.passenger?.email || 'N/A'}</Text></View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>ITINERARIO SOLICITADO</Text>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <Text style={styles.tableCellLabel}>Destino</Text>
              <Text style={styles.tableCell}>Fecha Salida</Text>
              <Text style={styles.tableCell}>Fecha Regreso</Text>
              <Text style={styles.tableCellLast}>Noches</Text>
            </View>
            {request.requestDestinations?.map((rd, i) => (
              <View key={i} style={styles.tableRow}>
                <Text style={styles.tableCellLabel}>{rd.destination ? `${rd.destination.destinationName} - ${rd.destination.country}` : 'N/A'}</Text>
                <Text style={styles.tableCell}>{formatDate(rd.departureDate)}</Text>
                <Text style={styles.tableCell}>{formatDate(rd.returnDate)}</Text>
                <Text style={styles.tableCellLast}>{rd.numberNights || 0}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>DETALLES GENERALES DEL VIAJE</Text>
          <View style={styles.row}><Text style={styles.label}>Ciudad de Origen:</Text><Text style={styles.value}>{request.origin || 'N/A'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Cantidad de Pasajeros:</Text><Text style={styles.value}>{request.numberPassengers || 0} Adultos / {request.numberChilds || 0} Niños / {request.numberInfants || 0} Bebés</Text></View>
          <View style={styles.row}><Text style={styles.label}>Política de Equipaje:</Text><Text style={styles.value}>{request.luggage || 'No especificado'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Presupuesto Estimado:</Text><Text style={styles.value}>${request.budget || 'N/A'}</Text></View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>PREFERENCIAS DE ALOJAMIENTO</Text>
          <View style={styles.row}><Text style={styles.label}>Tipo de Alojamiento:</Text><Text style={styles.value}>{accommodationMap[request.accommodationPreference] || 'Indiferente'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Categoría:</Text><Text style={styles.value}>{categoryMap[request.category] || 'Indiferente'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Régimen de Comidas:</Text><Text style={styles.value}>{mealPlanMap[request.mealPlan] || 'Indiferente'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Tipo de Habitación:</Text><Text style={styles.value}>{roomTypeMap[request.roomType] || 'Indiferente'}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Ubicación deseada:</Text><Text style={styles.value}>{request.ubicacion || 'No especificada'}</Text></View>
        </View>

        <View style={styles.section}>
          <Text style={sectionTitleStyle(styles)}>SERVICIOS ADICIONALES REQUERIDOS</Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 20, marginTop: 5 }}>
            <Text>Transfer: [{request.transfer ? 'X' : ' '}]</Text>
            <Text>Alquiler Auto: [{request.carRental ? 'X' : ' '}]</Text>
            <Text>Excursiones: [{request.excursion ? 'X' : ' '}]</Text>
            <Text>Seguro de Viaje: [{request.traveInsurance ? 'X' : ' '}]</Text>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>OBSERVACIONES Y NOTAS</Text>
          <Text style={{ fontWeight: 'bold', marginBottom: 2 }}>Anotaciones:</Text>
          <View style={styles.textBlock}><Text>{request.annotations || 'Sin anotaciones.'}</Text></View>
          
          <Text style={{ fontWeight: 'bold', marginBottom: 2, marginTop: 10 }}>Necesidades Especiales:</Text>
          <View style={styles.textBlock}><Text>{request.specialNeeds || 'Sin necesidades especiales registradas.'}</Text></View>
          
          <Text style={{ fontWeight: 'bold', marginBottom: 2, marginTop: 10 }}>Comentarios Adicionales:</Text>
          <View style={styles.textBlock}><Text>{request.comments || 'Sin comentarios.'}</Text></View>
        </View>
      </Page>
    </Document>
  );
};

// Helper para evitar errores si el estilo no carga correctamente en algún entorno
const sectionTitleStyle = (s) => s.sectionTitle;

export default RequestDocument;